import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from 'react';
import { VariableSizeList as _VariableSizeList, } from 'react-window'; // TODO: upgrade to v2
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
// Cast to work around react-window types being incompatible with React 18 types.
const VariableSizeList = _VariableSizeList;
const LIST_ROW_HEIGHT = 48;
const useStyles = makeStyles()(() => ({
    searchInput: {
        lineHeight: 'initial',
        height: 'auto !important',
    },
}));
// Context to forward outer element props for the virtualized listbox.
const OuterElementContext = React.createContext({});
const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext);
    return _jsx("div", { ref: ref, ...props, ...outerProps });
});
function ListRow(props) {
    const { data, index, style } = props;
    const dataSet = data[index];
    const inlineStyle = {
        ...style,
        top: style.top + 8,
    };
    // This array is created by the renderOption function in the Autocomplete component.
    const [props0, option, getItemLabel] = dataSet;
    const { key, ...optionProps } = props0;
    return (_jsx(Typography, { component: "li", ...optionProps, noWrap: true, style: inlineStyle, children: getItemLabel(option) }, key));
}
function useResetCache(itemCount) {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [itemCount]);
    return ref;
}
// Virtualized listbox based on:
// https://mui.com/material-ui/react-autocomplete/#virtualization
const ListboxComponent = React.forwardRef((props, ref) => {
    const { children, ...other } = props;
    const items = children;
    const itemCount = items.length;
    const gridRef = useResetCache(itemCount);
    return (_jsx("div", { ref: ref, children: _jsx(OuterElementContext.Provider, { value: other, children: _jsx(VariableSizeList, { height: Math.min(8, itemCount) * LIST_ROW_HEIGHT, itemSize: () => LIST_ROW_HEIGHT, width: "100%", innerElementType: "ul", outerElementType: OuterElementType, overscanCount: 5, ref: gridRef, itemCount: itemCount, itemData: items, children: ListRow }) }) }));
});
/**
 * A reusable virtualized autocomplete for searching genes (and other
 * ontology nodes such as proteins, pathways, or cell types).
 *
 * The caller supplies an async `getMatches` function that receives
 * the current input value and returns matching `AutocompleteItem[]`.
 */
export function SimpleAutocomplete(props) {
    const { getMatches, onChange, textInputLabel = 'Enter a gene', getItemLabel = (option) => option.label, } = props;
    const { classes } = useStyles();
    const [potentialItems, setPotentialItems] = useState([]);
    const handleInputChange = async (_event, value) => {
        if (!value) {
            setPotentialItems([]);
            return;
        }
        const results = await getMatches(value);
        setPotentialItems(results);
    };
    return (_jsx(Autocomplete, { options: potentialItems, autoComplete: true, includeInputInList: true, onInputChange: handleInputChange, onChange: (_event, item) => onChange(item), classes: { input: classes.searchInput }, renderInput: params => (_jsx(TextField, { label: textInputLabel, variant: "outlined", ...params })), getOptionLabel: option => option.label, renderOption: (props0, option, state) => [props0, option, getItemLabel, state.index], slotProps: {
            listbox: {
                component: ListboxComponent,
            },
        } }));
}
//# sourceMappingURL=SimpleAutocomplete.js.map